<template>
    <div class="col-12 form-group">
        <page-header :title="title" :items="items" />

        <setting-files-dropzones
            climate-files-type="office_rating_calculations"
        />
    </div>
</template>

<script>
import settingFilesDropzones from '@/components/file/SettingFilesDropzones';

export default {
    page: {
        title: 'Greener - Office rating settings'
    },
    components: {
        settingFilesDropzones
    },

    data() {
        return {
            title: 'Office rating settings',
            items: [
                {
                    text: 'Greener',
                    to: '/'
                },
                {
                    text: 'Office rating settings',
                    active: true
                }
            ]
        };
    },

    methods: {}
};
</script>
